import * as analyticsService from "@store/Services/AnalyticsService";
import React, { useEffect, useRef } from "react";

export const usePrevious = (value: any) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export const useAnalytics = () => {
    return analyticsService;
};
